import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';

import { RootState } from 'src/app/reducers';
import { Log } from 'src/app/utils/log';
import { redirectPage } from 'src/app/actions/core.actions';
import { enter } from '../../../resources/animations';
import { AppEvent } from '../../../models/event-log';
import { reportAppEvent } from '../../../actions/event-log.actions';

@Component({
  selector: 'app-word-download-alert-dialog',
  templateUrl: './word-download-alert-dialog.component.html',
  styleUrls: ['./word-download-alert-dialog.component.scss'],
  animations: [enter]
})
export class WordDownloadAlertDialogComponent implements OnInit {
  disabled = false;
  doNotShowAgain = false;
  private LOG_SOURCE = this.constructor.name;

  constructor(
    private store: Store<RootState>,
    private dialogRef: MatDialogRef<WordDownloadAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { problemId: string; wordUrl: string }
  ) {}

  ngOnInit() {}

  downloadWord() {
    if (!this.data) {
      Log.warn(this.LOG_SOURCE, `dialog.data が設定されていません: `, this.data);
      return;
    }

    if (this.doNotShowAgain) {
      localStorage.setItem('doNotWordDownloadAlertShowAgain', 'true');
    }

    this.store.dispatch(redirectPage({ url: this.data.wordUrl }));

    const subjectId = this.data.problemId.slice(6, 8);
    const selectedProblemWord = `${this.data.problemId}.docx`;
    const appEvent: AppEvent = {
      type: 'select-problem-word',
      value: JSON.stringify({
        subjectId,
        selectedProblemWord
      })
    };
    setTimeout(() => this.store.dispatch(reportAppEvent({ event: appEvent })));
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
